import React, { Component } from 'react';
import { Table, Modal, Button } from 'react-bootstrap';
import InformationLayerMap from '../../InformationLayerMap';

class InformationBulkUpdateFiltersList extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            items: [],
            showMapModal: false
        };
    }

    handleShowMap = () => {
        this.setState({ showMapModal: true });
    };

    handleCloseMap = () => {
        this.setState({ showMapModal: false });
    };

    render() {
        const filters = this.props.items || this.state.items;
        const { searchArea } = this.props;
        const filtersCount = (filters?.length || 0) + (searchArea ? 1 : 0);

        return (
            <div className="information-bulk-update-card information-bulk-update-card--filters-list">
                <div className="information-bulk-update-card__header">
                    <div>
                        <h5 className="mb-1">Aktywne filtry</h5>
                        <p className="mb-0 text-muted">
                            Łącznie aktywnych warunków: {filtersCount}
                        </p>
                    </div>
                </div>
                <div className="information-bulk-update-card__body">
                    <Table responsive hover size="sm" className="table-modern align-middle">
                            <thead>
                                <tr>
                                    <th>Nazwa</th>
                                    <th>Wartość</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(!filters || filters.length === 0) && !searchArea && (
                                    <tr className="table-modern-empty">
                                        <td colSpan={2} className="text-center text-muted py-4">
                                            <div className="information-bulk-update-empty-state">
                                                <span className="information-bulk-update-empty-state__title">Brak filtrów</span>
                                                <small className="text-muted">Nie dodano żadnych kryteriów wyszukiwania.</small>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                                {searchArea && (
                                    <tr>
                                        <td>
                                            <span className="badge bg-success text-white">
                                                <i className="bi bi-geo-alt-fill me-1"></i>
                                                Obszar wyszukiwania
                                            </span>
                                        </td>
                                        <td>
                                            <span 
                                                className="badge bg-light text-success border border-success px-3 py-2" 
                                                style={{ cursor: 'pointer' }}
                                                onClick={this.handleShowMap}
                                            >
                                                📍 Kliknij aby zobaczyć mapę
                                            </span>
                                        </td>
                                    </tr>
                                )}
                                {filters && filters.map((item, idx) => {
                                    if (React.isValidElement(item)) {
                                        return (
                                            <tr key={item.key || idx}>
                                                <td>
                                                    <span className="badge text-bg-primary-subtle border border-primary-subtle">
                                                        Element {idx + 1}
                                                    </span>
                                                </td>
                                                <td>{item}</td>
                                            </tr>
                                        );
                                    }
                                    if (Array.isArray(item) && item.length >= 2) {
                                        return (
                                            <tr key={idx}>
                                                <td>{String(item[0])}</td>
                                                <td className="text-break">{String(item[1]) || <span className="text-muted">-</span>}</td>
                                            </tr>
                                        );
                                    }
                                    const {
                                        name,
                                        label,
                                        key,
                                        id,
                                        filterName,
                                        value,
                                        val,
                                        display,
                                        component,
                                        Component,
                                        props = {}
                                    } = item || {};
                                    const resolvedName = name || filterName || label || key || id || `Filter ${idx + 1}`;
                                    const resolvedValue =
                                        value !== undefined ? value :
                                        val !== undefined ? val :
                                        display !== undefined ? display :
                                        props.value !== undefined ? props.value :
                                        props.label !== undefined ? props.label :
                                        (item != null ? String(item) : '');
                                    const shownValue = (resolvedValue === '' || resolvedValue == null)
                                        ? <span className="text-muted">-</span>
                                        : String(resolvedValue);
                                    return (
                                        <tr key={key || id || idx}>
                                            <td>{resolvedName}</td>
                                            <td className="text-break">{shownValue}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
            </Table>
                </div>

                {/* Modal z podglądem mapy */}
                <Modal show={this.state.showMapModal} onHide={this.handleCloseMap} size="xl" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Podgląd obszaru wyszukiwania</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: 0 }}>
                        <div style={{ height: '60vh', minHeight: '400px' }}>
                            <InformationLayerMap 
                                area={searchArea} 
                                color="#28a745"
                                editable={false}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseMap}>
                            Zamknij
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default InformationBulkUpdateFiltersList;